import Alpine from 'alpinejs';
import { preselectedAttribute } from './stores/preselected-attribute';
import { productImages } from './stores/product-images';
import { accordion } from './components/accordion';
import { nav } from './components/nav';
import { progressBar } from './components/progress-bar';
import { quickAdd } from './components/quick-add';
import { slider } from './components/slider';
import type { ComponentStore, StoreStore } from './global';
import { currentCountry } from './stores/current-country';
import { global } from './stores/global';
import './vanilla-js-stuff/main';
import { select } from './components/select';
import { cartCounters } from './stores/cart-counters';
import { sidebar } from './stores/sidebar';

const components = {
	slider,
	accordion,
	progressBar,
	quickAdd,
	nav,
	select
} as const satisfies ComponentStore;

const stores = {
	global,
	currentCountry,
	productImages,
	preselectedAttribute,
	cartCounters,
	sidebar
} as const satisfies StoreStore;

Object.entries(components).forEach(v => Alpine.data(...v));
Object.entries(stores).forEach(v => Alpine.store(...v));

window.Alpine = Alpine;

Alpine.start();
